var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractViewerNavbarButton } from "../viewerTemplatePlugin";
import { Tools } from "@babylonjs/core/Misc/tools";
var PrintButtonPlugin = /** @class */ (function (_super) {
    __extends(PrintButtonPlugin, _super);
    function PrintButtonPlugin(_viewer) {
        var _this = _super.call(this, "print", "print-button", PrintButtonPlugin.HtmlTemplate) || this;
        _this._viewer = _viewer;
        _this._viewer.onModelLoadedObservable.add(function (model) {
            _this._currentModelUrl = "";
            if (model.configuration.url) {
                var filename = Tools.GetFilename(model.configuration.url) || model.configuration.url;
                var baseUrl = model.configuration.root || Tools.GetFolderPath(model.configuration.url);
                //gltf, obj, stl
                var extension_1 = model.configuration.loader || filename.split(".").pop() || "";
                var printable_1 = false;
                // not using .some sue to IE11
                ["gltf", "glb", "obj", "stl"].forEach(function (ext) {
                    if (extension_1.indexOf(ext) !== -1) {
                        printable_1 = true;
                    }
                });
                if (printable_1) {
                    _this._currentModelUrl = baseUrl + filename;
                }
            }
        });
        return _this;
    }
    PrintButtonPlugin.prototype.onEvent = function (event) {
        if (this._currentModelUrl) {
            var printUrl = this._currentModelUrl.replace(/https?:\/\//, "com.microsoft.builder3d://");
            window.open(printUrl, "_self");
        }
    };
    PrintButtonPlugin.HtmlTemplate = "\n{{#unless hidePrint}}\n<style>\n\n/* Show only if it's a windows 10 printer  */\n.print-icon.not-win-10 {\n    display: none;\n}\n\n.print-icon:after {\n    font-size: 16px;\n    content: \"\\E914\";\n}\n\n</style>\n<button class=\"print-button " + (window.navigator.userAgent.indexOf("Windows NT 10.0") === -1 ? "no-win-10" : "") + "\" title=\"{{text.printButton}}\">\n     <span class=\"icon print-icon\"></span>\n </button>\n {{/unless}}\n";
    return PrintButtonPlugin;
}(AbstractViewerNavbarButton));
export { PrintButtonPlugin };
//# sourceMappingURL=printButton.js.map